import { categoriesStyles as styles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.title = {
    ...styles.title,
    as: "h3",
    variant: "h3",
    css: css`
        ${styles.title?.css}
        margin-bottom: 10px;
    `,
};

styles.categoryNameLink = {
    ...styles.categoryNameLink,
    color: colorStrings.textLink,
};

styles.categoryImageLink = {
    ...styles.categoryImageLink,
    mergeCss: true,
    typographyProps: {
        ...styles.categoryImageLink?.typographyProps,
        css: css`
            ${styles.categoryImageLink?.typographyProps?.css}
            display: inline-flex;
        `,
    },
};

styles.categoryImage = {
    ...styles.categoryImage,
    mergeCss: true,
};

styles.subCategoryItem = {
    ...styles.subCategoryItem,
    css: css`
        ${styles.subCategoryItem?.css}
        padding-left: 10px;
    `,
};
